<template>
  <div>
    <v-toolbar clipped-right v-if ="$store.state.isUserLoggedIn">
      <v-toolbar-side-icon  @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <router-link to="/Dashboard">
          <div class="items">
            <img src="../assets/nxtagro.png" alt="" id="logo">
          </div>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">

        <h5 class="user" >{{$store.state.user.email}}</h5>

        <div class="login">
          <v-btn
            v-if ="!$store.state.isUserLoggedIn"
            flat
            small
            @click="navigateTo({name: 'Login'})">
            Login
          </v-btn>
          <v-btn
            id="logout"
            v-if ="$store.state.isUserLoggedIn"
            flat
            small
            @click="logout">
            Log Out
          </v-btn>
        </div>
      </v-toolbar-items>
    </v-toolbar>
    
    <v-navigation-drawer
      v-model="drawer"
      temporary
      absolute
      width = "200"
      id = "drawer"
    >
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        
        <v-list-tile>
          <v-btn
            v-if ="$store.state.isUserLoggedIn"
            flat
            @click="logout">
            <v-icon>{{ 'close' }} </v-icon>
              Log Out
          </v-btn>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div> 
</template>

<script>
  import io from "socket.io-client";

  export default {
    data: () => ({
      mini: true,
      drawer: null, 
      items: [
        { title: 'DASHBOARD', icon: 'dashboard', url: '/Dashboard' },
        { title: 'ANÁLISIS FOLIAR', icon: 'zoom_in', url: '/FoliageReport' },
        { title: 'PLAGAS', icon: 'bug_report', url: '/Plagas' },
        { title: 'SENSORES', icon: 'settings_input_antenna', url: '/Sensors' },
        { title: 'REPORTES', icon: 'assignment', url: '/Reports' },
      ],
      right: null,
      alerts: null,
      showAlert: false
    }),
    mounted() {
      if (!this.$store.state.isUserLoggedIn) {
        this.$router.push("/")
      }
    },
    methods: {
      navigateTo(route){
        this.$router.push(route)
      },
      logout () {
        this.$store.dispatch('setToken', null)
        this.$store.dispatch('setUser', null)
        this.$router.push({
          name: 'Login'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  .router-link-active {
    .items {
      .item {
        font-weight: bold;
        color: rgb(135, 174, 110) !important;
      }
    }
  }

  .user {
    margin-top: 0px;
  }

  .pt-0 {
    margin-top:60px;
  }

  .v-toolbar {
    background-color: white !important;
    z-index: 99999;
  }

  .hidden-sm-and-down {
    position: relative;
    left: -30% !important;
  }

  .items {
    display: block;
    left: -10% !important;
    width: 100% !important;
  }

  #logo {
    position: absolute;
    margin-top: -10px;
    margin-left: 3%;
    max-height: 10rem !important;
    max-width: 10rem !important;
    display: block;
  }

 .v-toolbar__items {
    margin-top: 40px !important;
    margin-left: 20% !important;
  }

  .fa-lock {
    margin-left: 5px;
  }

  .locked {
    color:#BDBDBD!important; 
    cursor: not-allowed !important;
  }

  .alertButton {
    position: fixed !important;
    margin-left: 10px !important;
    height: 100%;
  }

  #alertIcon {
    font-size: 25px !important;
    margin-left: -10px !important;
    position: absolute;
    display: block;
  }

  .alertBox {
    border-radius: 7px;
    // box-shadow: 5px 5px 5px 4px #F5F5F5;
    margin-top: 310px;
    width: 350px !important;
  }

  .notification {
    margin-bottom: 2px;
    height: 120px !important;
    padding: 20px 20px 20px 20px;
    cursor: pointer;
    background-color: #F44336 !important;
    color: white;
    opacity: .97;
  }

  .danger {
    background-color: red !important;
    margin-bottom: 5px !important;
  }

  #logout {
    border: 1.5px solid rgb(135, 174, 110);
    border-radius: 4px;
    color: #757575!important;
  }


  @media only screen and (max-height: 700px) {
    .hidden-sm-and-down {
      position: relative;
      left: -15% !important;
    }

    .login {
      margin-left: -10% !important;
      /* position: absolute; */
      display: block;
      float: right !important;
    }
  }

  @media only screen and (min-height: 500px) {
    .hidden-sm-and-down {
      position: relative;
      left: -17% !important;
    }

    .login {
      margin-left: 15% !important;
      /* position: absolute; */
      display: block;
      float: right !important;
    }
  }

</style>
